// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as IndexRouteImport } from './routes/index'

const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ThankYouRoute: ThankYouRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)